/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meetings_Kinds_TitleInputs */



/**
* | output |
* | --- |
* | "Which conversations" |
*
* @param {Meetings_Kinds_TitleInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meetings_kinds_title = /** @type {((inputs?: Meetings_Kinds_TitleInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meetings_Kinds_TitleInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Welke gesprekken")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Quelles conversations")
	return /** @type {LocalizedString} */ ("Which conversations")
});